import { Slider } from "./slider";

export { Slider };
